import Swiper, { Navigation, Pagination, Lazy, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const sliderActions = document.querySelector(".js-slider-actions");

if (sliderActions) {
    const slides = sliderActions.querySelectorAll(".swiper-slide");

    if (slides.length > 1) {
        new Swiper(".js-slider-actions-swiper", {
            loop: true,
            speed: 300,
            watchSlidesVisibility: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".js-slider-actions-pagination",
                clickable: true,
            },
            observeParents: true,
            observer: true,
            observeSlideChildren: true,
        });
    } else {
        const actions = sliderActions.querySelector(".js-slider-actions-pagination");

        if (actions) {
            actions.style.display = "none";
        }
    }
}
